export const FETCHING = 'FETCHING';
export const FAILED = 'FAILED';
export const ERROR = 'ERROR';
export const PLAN = 'PLAN';
